import React, { useState, useRef, Fragment, useEffect } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
// import { useSelector } from "react-redux"

import {
  // calculateTotalTaxes,
  // convertOrderCombosToCartCombos,
  // convertOrderItemsToCartItems,
  // createOfflineOrder,
  ObjectValues
} from "utils"
import { changeOrderStatusToDelivered } from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./PoCompleteOrdersButton.module.scss"
import clsx from "clsx"

const PoCompleteOrdersButton = props => {
  const {
    setOrders,
    selectedOrders,
    setSelectedOrders
  } = props

  const [t, i18n] = useTranslation()

  // const isOnline =
  //   useSelector(state =>
  //     state.internetStatus.online &&
  //     !state.internetStatus.forceOffline
  //   )

  const [sending, setSending] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const unmount = useRef(false)

  // const handleOfflineCompleteOrders = () => {
  //   for (const order of orders) {
  //     const totalDiscount =
  //       order.deliveryDiscount +
  //       order.foodDiscount

  //     const totalTaxes =
  //       calculateTotalTaxes(order)

  //     const offlineOrderDetails = {
  //       branchId: order.branchId,
  //       onlineOrderId: order._id,
  //       totalDiscount,
  //       totalTaxes,
  //       totalCharges: 0,
  //       code: order.code,
  //       total: order.totalBillAmount,
  //       orderStatus: "delivered",
  //       onlineInitialOrderStatus: "paid",
  //       deliveryType: order.deliveryType,
  //       deliveryAddress: order.address,
  //       deliveryService: order.deliveryService,
  //       order: {
  //         tableNumber: order.tableNumber,
  //         items: convertOrderItemsToCartItems(order.items),
  //         combos: convertOrderCombosToCartCombos(order.items)
  //       },
  //       deliveryFees: {
  //         fee: order.deliveryFee
  //       }
  //     }

  //     createOfflineOrder(offlineOrderDetails)
  //   }
  // }

  const handleCompleteOrders = async () => {
    setSending(true)

    for (const order of orders) {
      try {
        await changeOrderStatusToDelivered(order._id)

        setSelectedOrders(prev => {
          const previousSelectedOrders = { ...prev }

          delete previousSelectedOrders[order._id]

          return previousSelectedOrders
        })

        setOrders(prev =>
          prev.map(o =>
            o._id === order._id
              ? { ...o, orderStatus: "delivered" }
              : o
          )
        )
      } catch (err) {
        console.log(err)

        toast.error(t("سفارش_تکمیل_نشد"))
      }
    }

    setSending(false)

    setShowConfirmationModal(false)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  const orders =
    ObjectValues(selectedOrders)

  const showButton = orders.length > 0

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showButton) return null

  return (
    <Fragment>
      <Button
        color="success"
        loading={sending}
        onClick={() => setShowConfirmationModal(true)}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        {t("تکمیل_سفارشات")}
      </Button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_سفارشات_انتخاب_شده_را_تکمیل_کنید")}
        show={showConfirmationModal}
        onConfirm={handleCompleteOrders}
        onHide={() => setShowConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default PoCompleteOrdersButton